import axios from "axios";

// Project import
import { GeoLocationAddress } from "types/geoLocation";
import { getGoogleMapsApiKey } from 'contexts/FirebaseContext';

// ------------------ Address --> Lat/Lng ------------------
const baseurl = (apiKey: string) =>
    "https://maps.googleapis.com/maps/api/geocode/json?key="+apiKey+"&address=";

export async function googleGeoCodeingGetGeolocaion(address: GeoLocationAddress) {
   const searchAddress = encodeURIComponent(Object.values(address).join(","));
   const key = await getGoogleMapsApiKey();
   if (!key) throw new Error("missing credentials in get geoLocation");
   return axios.get(baseurl(key)+searchAddress);
}

// ------------------ Lat/Lng --> Address ------------------
const reverseGeocodeBaseUrl = (apiKey: string) =>
    "https://maps.googleapis.com/maps/api/geocode/json?key=" + apiKey + "&latlng=";

type LatLong = {
    lat: number;
    lng: number;
};
export async function googleGeocodingReverseGeocode(latLong: LatLong, language?: string) {
    const { lat, lng } = latLong;
    const latLngParam = encodeURIComponent(`${lat},${lng}`);
    const key = await getGoogleMapsApiKey();
    if (!key) throw new Error("missing credentials in reverse geocode");
    const languageParam = language ? `&language=${encodeURIComponent(language)}` : "";
    return axios.get(reverseGeocodeBaseUrl(key) + latLngParam + languageParam);
}
